<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<p class="para"> </p>
<p class="para"> </p>
<h2 class="ded"><em>If you’re going to seek revenge, dig two graves.</em></h2>
<h2 class="ded1">Chinese proverb</h2>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?e76d8c64